import { query, writeQuery } from '@confluence/query-preloader-tools';
import { GetCollabServiceWithMigrationQuery } from '@confluence/native-collab/entry-points/CollabServiceWithMigrationQuery';
import type {
	getCollabServicePropertyQueryRes,
	getCollabServicePropertyQueryVariables,
} from '@confluence/native-collab/entry-points/CollabServiceWithMigrationQuery';
import { NativeCollabQuery } from '@confluence/native-collab/entry-points/NativeCollabQuery';
import type {
	NativeCollabQueryRes,
	NativeCollabQueryVariables,
} from '@confluence/native-collab/entry-points/NativeCollabQuery';
import { NativeCollabProviderQuery } from '@confluence/fabric-providers/entry-points/NativeCollabProviderQuery';
import type {
	NativeCollabProviderQueryRes,
	NativeCollabProviderQueryVariables,
} from '@confluence/fabric-providers/entry-points/NativeCollabProviderQuery';
import { CollabDraftQuery } from '@confluence/fabric-providers/entry-points/CollabDraftQuery';
import type {
	CollabDraftQueryRes,
	CollabDraftQueryVariables,
} from '@confluence/fabric-providers/entry-points/CollabDraftQuery';

export function preloadCollabDraftContent(
	contentId: string,
	shouldPreloadNativeEditorData: boolean,
) {
	return query<CollabDraftQueryRes, CollabDraftQueryVariables>({
		query: CollabDraftQuery,
		variables: {
			id: contentId,
		},
		fetchPolicy: shouldPreloadNativeEditorData ? 'cache-first' : 'network-only',
	});
}

export function updateCollabDraftContent(contentId: string, data: any) {
	return writeQuery<CollabDraftQueryRes, CollabDraftQueryVariables>({
		query: CollabDraftQuery,
		variables: { id: contentId },
		data,
	});
}

export function preloadNativeCollab(
	contentId: string,
	draftShareId: string | undefined,
	shouldPreloadNativeEditorData: boolean,
	status?: [string],
) {
	return query<NativeCollabQueryRes, NativeCollabQueryVariables>({
		query: NativeCollabQuery,
		variables: {
			contentId,
			...(draftShareId && { draftShareId }),
			status: status ?? ['draft', 'current'],
		},
		fetchPolicy: shouldPreloadNativeEditorData ? 'cache-first' : 'network-only',
		context: { single: 'true' },
	});
}

export function preloadCollabServiceProperty(
	contentId: string,
	draftShareId: string | undefined,
	shouldPreloadNativeEditorData: boolean,
) {
	return query<getCollabServicePropertyQueryRes, getCollabServicePropertyQueryVariables>({
		query: GetCollabServiceWithMigrationQuery,
		variables: {
			contentId,
			...(draftShareId && { draftShareId }),
		},
		fetchPolicy: shouldPreloadNativeEditorData ? 'cache-first' : 'network-only',
		context: { single: 'true' },
	});
}

export function preloadNativeCollabProvider(
	accountId: string | null,
	shouldPreloadNativeEditorData: boolean,
) {
	return query<NativeCollabProviderQueryRes, NativeCollabProviderQueryVariables>({
		query: NativeCollabProviderQuery,
		variables: {
			accountId,
		},
		fetchPolicy: shouldPreloadNativeEditorData ? 'cache-first' : 'network-only',
		context: { single: 'true' },
	});
}
